import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {PermissionProvider} from '@xmedical/core';

@Injectable({
  providedIn: 'root'
})
export class PortalPermissionProvider extends PermissionProvider {
  private _permissionsLoaded$ = of<void>(undefined);

  hasPermission(_permission: string): boolean {
    return true;
  }

  get hasPermissions(): boolean {
    return true;
  }

  get permissionsLoaded$(): Observable<void> {
    return this._permissionsLoaded$;
  }
}
